import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { REQUEST_GENERAL_REPORTS_DATA } from 'partner360/features/generalReports/constants'
import { IGeneralReportsResponse } from 'partner360/models/report/generalReports/IGeneralReportsResponse'
import { fetchGeneralReportsSettings } from 'partner360/services/report/fetchGeneralReportsSettings'

export const requestGeneralReportsData = createAsyncThunk<IGeneralReportsResponse>(
  REQUEST_GENERAL_REPORTS_DATA,
  async () => {
    return await fetchGeneralReportsSettings()
  }
)
